import { DropdownIndicatorProps, GroupBase, components } from "react-select";
import { JSX } from "react";
import { ReactSelectItem } from "/Helpers/ReactSelectItem";
import { ColorTheme } from "/Models/Models/ColorTheme";

interface OptionPickerDropdownIndicatorProps {
  isOpen: boolean;
  reactSelectProps: DropdownIndicatorProps<
    ReactSelectItem,
    boolean,
    GroupBase<ReactSelectItem>
  >;
}

const OptionPickerDropdownIndicator = (
  props: OptionPickerDropdownIndicatorProps,
): JSX.Element => {
  return (
    <components.DropdownIndicator {...props.reactSelectProps}>
      <div style={{ display: "flex", alignItems: "center" }}>
        {props.isOpen ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={ColorTheme.iconStrong}
          >
            <path d="M20.0306 15.5306C19.961 15.6004 19.8782 15.6557 19.7872 15.6934C19.6961 15.7312 19.5986 15.7506 19.5 15.7506C19.4014 15.7506 19.3038 15.7312 19.2128 15.6934C19.1217 15.6557 19.039 15.6004 18.9694 15.5306L12 8.56031L5.03061 15.5306C4.88988 15.6714 4.69901 15.7504 4.49999 15.7504C4.30097 15.7504 4.1101 15.6714 3.96936 15.5306C3.82863 15.3899 3.74957 15.199 3.74957 15C3.74957 14.801 3.82863 14.6101 3.96936 14.4694L11.4694 6.96937C11.539 6.89964 11.6217 6.84432 11.7128 6.80658C11.8038 6.76883 11.9014 6.7494 12 6.7494C12.0986 6.7494 12.1961 6.76883 12.2872 6.80658C12.3782 6.84432 12.461 6.89964 12.5306 6.96937L20.0306 14.4694C20.1003 14.539 20.1557 14.6217 20.1934 14.7128C20.2312 14.8038 20.2506 14.9014 20.2506 15C20.2506 15.0986 20.2312 15.1962 20.1934 15.2872C20.1557 15.3782 20.1003 15.461 20.0306 15.5306Z" />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill={ColorTheme.iconStrong}
          >
            <path d="M20.0306 9.53063L12.5306 17.0306C12.461 17.1004 12.3782 17.1557 12.2872 17.1934C12.1961 17.2312 12.0986 17.2506 12 17.2506C11.9014 17.2506 11.8038 17.2312 11.7128 17.1934C11.6217 17.1557 11.539 17.1004 11.4694 17.0306L3.96936 9.53063C3.82863 9.3899 3.74957 9.19903 3.74957 9.00001C3.74957 8.80098 3.82863 8.61011 3.96936 8.46938C4.1101 8.32865 4.30097 8.24959 4.49999 8.24959C4.69901 8.24959 4.88988 8.32865 5.03061 8.46938L12 15.4397L18.9694 8.46938C19.039 8.3997 19.1218 8.34442 19.2128 8.30671C19.3039 8.269 19.4014 8.24959 19.5 8.24959C19.5985 8.24959 19.6961 8.269 19.7872 8.30671C19.8782 8.34442 19.9609 8.3997 20.0306 8.46938C20.1003 8.53906 20.1556 8.62179 20.1933 8.71283C20.231 8.80388 20.2504 8.90146 20.2504 9.00001C20.2504 9.09855 20.231 9.19613 20.1933 9.28718C20.1556 9.37822 20.1003 9.46095 20.0306 9.53063Z" />
          </svg>
        )}
      </div>
    </components.DropdownIndicator>
  );
};

export default OptionPickerDropdownIndicator;
